<template>
  <div id="page">
    <NavBarHome />

    <main
      v-if="location"
      class="pattern"
    >
      <!-- SEARCH  -->
      <section class="hero_single version_5">
        <div class="wrapper">
          <div
            class="container"
            style="margin-top: 3rem;"
          >
            <div class="row justify-content-center pt-lg-5">
              <div class="col-xl-5 col-lg-6 search-right-margin">
                <h3 class="home_title">
                  {{ $t('lang.locker_home.search_title', {location: location.short_name}) }}
                </h3>
                <h1 class="home_subtitle">
                  {{ $t('lang.locker_home.search_subtitle', {location: location.name}) }}
                </h1>

                <div class="custom-search-input-2">
                  <LockerSearchForm :set-location="searchPlace" />
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 text-right d-none d-lg-block illustration-left-margin">
                <img
                  src="../assets/img/illustrations/Travelers-home.png"
                  alt="Viajeros usando lockers WeKeep"
                  title="Lockers para equipaje"
                  class="img-fluid"
                >
              </div>
            </div>
          </div>
          <ScrollableBenefits />
        </div>
      </section>

      <!--  HOW IT WORKS  -->
      <div id="how">
        <div class="wrapper">
          <div class="container margin_80_55">
            <div class="main_title_2">
              <span><em /></span>
              <h2>{{ $t('lang.locker_home.how_works_title') }}</h2>
              <h3>{{ $t('lang.locker_home.how_works_subtitle') }}</h3>
            </div>
            <div class="row how_works_section">
              <div class="col-lg-12">
                <LockerHowWorksCarousel />
              </div>
              <div class="col-lg-12 text-center">
                <a
                  :href="'/'+ location.search_code"
                  class="btn_1 rounded"
                >
                  {{ $t('lang.locker_home.availability_button') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  LOCATION RESUME  -->
      <div
        id="city_info"
        class="call_section"
      >
        <div class="container margin_80_55">
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.locker_home.waiting', {location: location.name}) }}</h2>
            <h3>{{ $t('lang.locker_home.waiting_subtitle') }}</h3>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <p v-html="$t(`lang.locker_home.location_intro.${location.id}`)" />
            </div>
          </div>
        </div>
      </div>

      <!--  BEST PLACES CITY  -->
      <div id="city_more_info">
        <div class="container margin_80_55">
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.locker_home.best_places_title', {location: cityName}) }}</h2>
            <h3>{{ $t('lang.locker_home.best_places_subtitle') }}</h3>
          </div>
          <div class="row centered">
            <ul
              class="main-color-list centered"
              v-html="$t(`lang.city_home.city_places.${location.city_id}`)"
            />
          </div>
        </div>
      </div>
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import NavBarHome from '../components/NavBar/NavBarHome';
import LockerSearchForm from '../components/Search/LockerSearchForm';
import FooterComponent from '../components/FooterComponent';
import ScrollableBenefits from '@/components/Home/ScrollableBenefits.vue';
import LockerHowWorksCarousel from '@/components/Home/LockerHowWorksCarousel';
import { lockerLocations } from '@/data/lockerLocations';

export default {
  name: 'LockerHome',
  components: {
    ScrollableBenefits,
    LockerHowWorksCarousel,
    LockerSearchForm,
    NavBarHome,
    FooterComponent,
  },

  computed: {
    location() {
      const locationId = this.$route.params.location;
      return lockerLocations.find((l) => l.id === locationId);
    },
    searchPlace() {
      return {
        geometry: this.location.geometry,
        formatted_address: this.location.name,
      };
    },
    cityName() {
      return this.$t(`lang.cities.${this.location.city_id}`);
    },
  },
  mounted() {
    this.$store.dispatch('setCurrency', 'ARS');
  },
};
</script>
